import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "../components/ProtectedRoute";
import Loader from "../components/Loader";


import Layout from "../components/layout/Layout";
import LoginPage from "../pages/auth/LoginPage";

const Dashboard = lazy(() => import("../pages/Dashboard"));
const ReportsPage = lazy(() => import("../pages/ReportsPage"));
const Users = lazy(() => import("../pages/Users"));
const Jobs = lazy(() => import("../pages/Jobs"));
const JobDetailsPage = lazy(() => import("../pages/JobDetailsPage"));
const ApplicationListpage = lazy(() => import("../pages/ApplicationsList"));
const ApplicationDetailsPage = lazy(() => import("../pages/ApplicationDetailsPage"));
const BidListPage = lazy(() => import("../pages/BidsList"));
const BidDetailspage = lazy(() => import("../pages/BidDetailsPage"));
const ProfilePage = lazy(() => import("../pages/ProfilePage"));
const AdminSubscriptionsPage = lazy(() => import("../pages/AdminSubscriptionsPage"));
const AdminSubscriptionDetailPage = lazy(() => import("../pages/AdminSubscriptionDetailPage"));
const SettingsPage = lazy(() => import("../pages/SettingsPage"));
const SuccessPage = lazy(() => import("../pages/SuccessPage"));
const CancelPage = lazy(() => import("../pages/CancelPage"));
const PageManagement = lazy(() => import("../pages/PagesManagement"));
const PageView = lazy(() => import("../pages/PageView"));
const ReviewPage = lazy(()=> import("../pages/AdminReviews"))
const UserDetails = lazy(()=> import("../pages/UserDetails"))
const SupportTicketsDashboard = lazy(()=> import("../pages/SupportTicketsListPage.js"))
const AdminSupportTicketChat = lazy(()=> import("../pages/AdminSupportTicketChat.js"))
const OperationsPage = lazy(() => import("../pages/OperationsPage"));
const CancellationsPage = lazy(() => import("../pages/CancellationsPage"));
const BookingDetailsPage = lazy(() => import("../pages/BookingDetailsPage"));
const PromoCodesPage = lazy(() => import("../pages/PromoCodesPage"));
const NotFoundPage = lazy(() => import("../pages/NotFoundPage"));

export default function AppRoutes() {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>

        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/stripe/:id" element={<SuccessPage />} />
        <Route path="/stripe/payment/cancelled" element={<CancelPage />} />
        <Route path="/:slug" element={<PageView/>} />

        {/* Protected routes */}
        <Route element={<ProtectedRoute />}>
          <Route element={<Layout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/reports" element={<ReportsPage />} />
            <Route path="/users" element={<Users />} />
            <Route path="/users/:id" element={<UserDetails />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/jobs/:id" element={<JobDetailsPage />} />
            <Route path="/applications" element={<ApplicationListpage />} />
            <Route path="/applications/:id" element={<ApplicationDetailsPage />} />
            <Route path="/bids" element={<BidListPage />} />
            <Route path="/bids/:id" element={<BidDetailspage />} />
            <Route path="/subscriptions" element={<AdminSubscriptionsPage />} />
            <Route path="/subscriptions/:id" element={<AdminSubscriptionDetailPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/pages" element={<PageManagement />} />
            <Route path="/reviews" element={<ReviewPage />} />
            <Route path="/support-tickets" element={<SupportTicketsDashboard />} />
            <Route path="/support-tickets/:ticketId" element={<AdminSupportTicketChat />} />
            <Route path="/cancellations" element={<CancellationsPage />} />
            <Route path="/bookings/:id" element={<BookingDetailsPage />} />
            <Route path="/operations" element={<OperationsPage />} />
            <Route path="/promo-codes" element={<PromoCodesPage />} />
        </Route>
        </Route>

        <Route path="*" element={<NotFoundPage />} />

      </Routes>
    </Suspense>
  );
}
